import * as React from 'react';
import styled from 'styled-components';

// The SVG
const SvgBg = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 640 1500' {...props}>
    <defs>
      <style>
        {'.bg_svg__cls-48{stroke-width:1.51px;fill:#fff7f3;stroke:#fff7f3}'}
      </style>
      <clipPath id='bg_svg__clip-path'>
        <path fill='none' d='M0 1h640v1500H0z' />
      </clipPath>
    </defs>
    <g id='bg_svg__vertical'>
      <g clipPath='url(#bg_svg__clip-path)' id='bg_svg__BG'>
        <path
          d='M637.34 659.3l173 342.79 77-276.26z'
          strokeWidth={1.51}
          fill='#f465a1'
          stroke='#f465a1'
        />
        <path
          d='M751.34 606.63l-114 52.67 250 66.53z'
          fill='#f98aad'
          stroke='#f98aad'
          strokeWidth={1.51}
        />
        <path
          d='M751.34 606.63l-271-76.63 157 129.35z'
          fill='#fbaab8'
          stroke='#fbaab8'
          strokeWidth={1.51}
        />
        <path
          d='M458.34 1169.33l283 137.67 69-304.91z'
          fill='#a74b8e'
          stroke='#a74b8e'
          strokeWidth={1.51}
        />
        <path
          d='M632.34 323l-152 207 271 76.68z'
          fill='#fcbbc4'
          stroke='#fcbbc4'
          strokeWidth={1.51}
        />
        <path
          d='M682.34 233.35l-50 89.63 119 283.65z'
          fill='#febdcc'
          stroke='#febdcc'
          strokeWidth={1.51}
        />
        <path
          d='M443.34 1081.55l367-79.46-173-342.79z'
          fill='#e367a0'
          stroke='#e367a0'
          strokeWidth={1.51}
        />
        <path
          d='M239.34 863.5l204 218 194-422.25z'
          fill='#ef85ac'
          stroke='#ef85ac'
          strokeWidth={1.51}
        />
        <path
          d='M317.34 169.6l-22 459.21 185-98.86z'
          fill='#fdd9d5'
          stroke='#fdd9d5'
          strokeWidth={1.51}
        />
        <path
          d='M443.34 1081.55l15 87.78 352-167.24z'
          fill='#b95e97'
          stroke='#b95e97'
          strokeWidth={1.51}
        />
        <path
          d='M480.34 530l-185 98.86 342 30.49z'
          fill='#fcb9bc'
          stroke='#fcb9bc'
          strokeWidth={1.51}
        />
        <path
          d='M443.34 1081.55l-73 72.07 88 15.71z'
          fill='#af6999'
          stroke='#af6999'
          strokeWidth={1.51}
        />
        <path
          d='M317.34 169.6l163 360.4 152-207z'
          fill='#ffdad8'
          stroke='#ffdad8'
          strokeWidth={1.51}
        />
        <path
          d='M682.34 233.35l-147-71.14 97 160.77z'
          fill='#ffcbd4'
          stroke='#ffcbd4'
          strokeWidth={1.51}
        />
        <path
          d='M228.34 955l142 198.65 73-72.07z'
          fill='#c175a3'
          stroke='#c175a3'
          strokeWidth={1.51}
        />
        <path
          d='M295.34 628.81l-56 234.69 398-204.2z'
          fill='#fca9b9'
          stroke='#fca9b9'
          strokeWidth={1.51}
        />
        <path
          d='M644.34 1488.1l97-181.1-283-137.67z'
          fill='#a15290'
          stroke='#a15290'
          strokeWidth={1.51}
        />
        <path
          d='M695.34 145.58l-160 16.63 147 71.14z'
          fill='#ffc8d2'
          stroke='#ffc8d2'
          strokeWidth={1.51}
        />
        <path
          d='M317.34 169.6l218-7.39-245-103.49z'
          fill='#ffe2dd'
          stroke='#ffe2dd'
          strokeWidth={1.51}
        />
        <path
          d='M239.34 863.5l-11 91.47 215 126.58z'
          fill='#db81aa'
          stroke='#db81aa'
          strokeWidth={1.51}
        />
        <path
          d='M256.34 1501l388-12.93-186-318.77z'
          fill='#a36395'
          stroke='#a36395'
          strokeWidth={1.51}
        />
        <path
          d='M295.34 628.81l-240 16.63 184 218.06z'
          fill='#feb8c8'
          stroke='#feb8c8'
          strokeWidth={1.51}
        />
        <path
          d='M239.34 863.5l-282 124.73 271-33.26z'
          fill='#e491b9'
          stroke='#e491b9'
          strokeWidth={1.51}
        />
        <path
          d='M535.34 162.21l-218 7.39 315 153.4z'
          fill='#ffd8d7'
          stroke='#ffd8d7'
          strokeWidth={1.51}
        />
        <path
          d='M290.34 58.72l245 103.49 160-16.63z'
          fill='#fed7d7'
          stroke='#fed7d7'
          strokeWidth={1.51}
        />
        <path
          d='M25.34 338.68l30 306.76 240-16.63z'
          fill='#feddd9'
          stroke='#feddd9'
          strokeWidth={1.51}
        />
        <path
          d='M25.34 338.68l-7 316 37-9.24z'
          fill='#fee0db'
          stroke='#fee0db'
          strokeWidth={1.51}
        />
        <path
          d='M55.34 645.44l-37 9.24 221 208.82z'
          fill='#ffbccc'
          stroke='#ffbccc'
          strokeWidth={1.51}
        />
        <path
          d='M370.34 1153.62l-114 347.38 202-331.7z'
          fill='#a36a9b'
          stroke='#a36a9b'
          strokeWidth={1.51}
        />
        <path
          d='M228.34 955l-123 215.28 265-16.63z'
          fill='#ba7baa'
          stroke='#ba7baa'
          strokeWidth={1.51}
        />
        <path
          d='M-42.66 988.23l148 182 123-215.23z'
          fill='#ca88b4'
          stroke='#ca88b4'
          strokeWidth={1.51}
        />
        <path
          d='M1337.34 6.06l-1047 52.66 405 86.86z'
          fill='#ffb5ca'
          stroke='#ffb5ca'
          strokeWidth={1.51}
        />
        <path
          d='M317.34 169.6l-292 169.08 270 290.13z'
          fill='#ffebe7'
          stroke='#ffebe7'
          strokeWidth={1.51}
        />
        <path
          d='M18.34 654.68l-61 333.55 282-124.73z'
          fill='#f8a6c6'
          stroke='#f8a6c6'
          strokeWidth={1.51}
        />
        <path
          d='M18.34 654.68l-165-1.85 104 335.4z'
          fill='#ffb4ca'
          stroke='#ffb4ca'
          strokeWidth={1.51}
        />
        <path
          d='M290.34 58.72l-265 280 292-169.08z'
          fill='#ffeeea'
          stroke='#ffeeea'
          strokeWidth={1.51}
        />
        <path
          d='M-60.66 1527.83l317-26.8-151-330.78z'
          fill='#a57cac'
          stroke='#a57cac'
          strokeWidth={1.51}
        />
        <path
          d='M105.34 1170.25l151 330.78 114-347.41z'
          fill='#a372a4'
          stroke='#a372a4'
          strokeWidth={1.51}
        />
        <path
          d='M644.34 1488.1l-388 12.93 749 87.78z'
          fill='#a14e8f'
          stroke='#a14e8f'
          strokeWidth={1.51}
        />
        <path
          d='M1337.34 6.06l-1304-45.28 257 97.94z'
          fill='#ffd2d6'
          stroke='#ffd2d6'
          strokeWidth={1.51}
        />
        <path
          d='M25.34 338.68l-172 314.15 165 1.85z'
          fill='#fedfdb'
          stroke='#fedfdb'
          strokeWidth={1.51}
        />
        <path
          d='M25.34 338.68l-269 289.21 97 24.94z'
          fill='#fee0dc'
          stroke='#fee0dc'
          strokeWidth={1.51}
        />
        <path
          d='M25.34 338.68l-232-93.32-37 382.53z'
          fill='#fff1ed'
          stroke='#fff1ed'
          strokeWidth={1.51}
        />
        <path
          d='M290.34 58.72l-257-97.94-8 377.9z'
          fill='#fff4f0'
          stroke='#fff4f0'
          strokeWidth={1.51}
        />
        <path
          d='M1720.34-47.53l-1687 8.31 1304 45.28z'
          fill='#ec9ac0'
          stroke='#ec9ac0'
          strokeWidth={1.51}
        />
        <path
          className='bg_svg__cls-48'
          d='M33.34-39.22l-168 174.63 160 203.27zM-134.66 135.41l-72 110 232 93.32z'
        />
        <path
          d='M-200.66 1341.19l140 186.64 166-357.58z'
          fill='#a57dad'
          stroke='#a57dad'
          strokeWidth={1.51}
        />
        <path
          d='M-200.66 1341.19l306-170.94-148-182z'
          fill='#a97fae'
          stroke='#a97fae'
          strokeWidth={1.51}
        />
      </g>
    </g>
  </svg>
);

// Styled SVG for fullscreen
const BgSvgFullScreen = styled(SvgBg) `
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  pointer-events: none;
`;

export {
  BgSvgFullScreen,
};
